
<div class="contact pa-1">
    <v-row class="no-frame text-row" v-if="!contact">
        <v-col class="no-frame col-6 pr-1">
            <div class="name-box">&nbsp;</div>
        </v-col>
        <v-col class="no-frame col-6 right pr-1">
            <div class="name-box"></div>
        </v-col>
    </v-row>
    <v-row class="no-frame text-row" v-if="contact">
        <v-col class="no-frame col-6 pr-1">
            <!-- contact names -->
            <v-tooltip
                content-class = "custom-tooltip white"
                :open-delay   = "openDelay"
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        class  = "name-box"
                    >
                        <f-copy-text color="white--text" :text="name (contact)" class="copy-text"/>
                    </div>
                </template>

                <div class="lm-border primary-border-thick pa-2">
                    <div
                        v-for = "(name, index) in contact.names"
                        :key  = "index"
                        class = "tooltip-name"
                    >
                        {{ name }}
                    </div>
                </div>
            </v-tooltip>
            <!-- contact names -->
        </v-col>

        <v-col class="no-frame col-6 right pr-1">
            <!-- contact company -->
            <v-tooltip
                content-class = "custom-tooltip white"
                :open-delay   = "openDelay"
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                        class  = "name-box"
                    >
                        <f-copy-text color="white--text"  :text="contact.company.name"  class="w-100 right copy-text"/>
                    </div>
                </template>

                <div class="lm-border primary-border-thick pa-2 right">
                    <div class = "tooltip-name">
                        {{ contact.company.name }}
                    </div>
                </div>
            </v-tooltip>
            <!-- contact company -->
        </v-col>
    </v-row>
    <v-row class="no-frame text-row" v-if="contact" style="height: 18px;">
        <v-col class="no-frame pl-1">
            <f-copy-text  color="black--text" :text="phone" />
        </v-col>

        <v-col class="no-frame right pr-1">
            <f-copy-text color="black--text" :text="mobile" :right="true" />
        </v-col>
    </v-row>

    <v-row class="no-frame text-row" v-if="contact">
        <v-col class="no-frame">
            <v-tooltip
                content-class = "custom-tooltip white"
                :open-delay   = "openDelay"
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="v-flex"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <f-copy-text
                            :text = "contact.email"
                            color="black--text"
                        />
                        <a @click="onMail" class="black--text">
                            <div class="mr-1 ml-n1 w-100 contact-mail" style="margin-top: -1px"><v-icon color="primary">mdi-email</v-icon></div>
                        </a>
                    </div>
                </template>

                <div class="lm-border primary-border-thick pa-2">
                    <div
                        v-for = "(email, index) in contact.emails"
                        :key  = "index"
                        class = "tooltip-name v-flex"
                    >
                        <div style="margin-top: -1px" class="pr-1">
                            <v-icon :color="email.valid? 'primary':'error'">mdi-email</v-icon>
                        </div>
                        <div :class="email.valid?'':'error--text'">{{ email.address }}</div>
                    </div>
                </div>
            </v-tooltip>
        </v-col>
    </v-row>
</div>
